import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cs from "classnames";
import PropTypes from "prop-types";

import classes from "./NotificationButtons.module.scss";
import Icon from "../../atoms/Icon";
import { useModal } from "../../../hooks";
import { STORAGE } from "../../../constants";
import MailingModal from "../MailingModal/MailingModal";
import { isMobile } from "react-device-detect";
import { isMobileDevice } from "../../../utilities/helpers";
import ParentalGate from "../../molecules/ParentalGate/ParentalGate";

const NotificationButtons = ({ page }) => {
  const { t } = useTranslation();
  const videoNotificationPopup = useModal();
  const [gateOpen, setGateOpen] = useState(false);
  const [gateAction, setGateAction] = useState(null);
  let mailinglistID;

  const addClasses = () => {
    if (page == "illuminate") {
      mailinglistID = 3;
      return classes.illuminate;
    } else if (page == "daily-rebbe-video") {
      mailinglistID = 2;
      return classes.dailyRebbeVideo;
    } else {
      mailinglistID = 1;
    }

    return classes[page];
  };

  const getWhatsappLink = () => {
    if (page == "illuminate") return STORAGE.WHATSAPP_GROUP_LINK_ILLUMINATE;
    if (page == "daily-rebbe-video") return STORAGE.WHATSAPP_GROUP_LINK_DRV;
    return STORAGE.WHATSAPP_GROUP_LINK;
  };

  const openWhatsapp = () => {
    window.open(getWhatsappLink(), "_blank");
  };

  const handleWhatsappClick = () => {
    if (isMobileDevice()) {
      setGateAction(() => openWhatsapp);
      setGateOpen(true);
    } else {
      openWhatsapp();
    }
  };

  const handleEmailClick = () => {
    if (isMobileDevice()) {
      setGateAction(() => () => videoNotificationPopup.onOpen());
      setGateOpen(true);
    } else {
      videoNotificationPopup.onOpen();
    }
  };

  return (
    <>
      <div className={cs(addClasses())}>
        <div className={cs("mb-02 ta-center", isMobile && "mt-05", classes.heading)}>{t("pages.mymaor.texts.2")}</div>
      </div>
      <div className={classes.subscribeMailingAction}>
        <button
          className={classes.popupButton}
          onClick={handleWhatsappClick}
        >
          {" "}
          <Icon size="xs" name="whatsapp" />
          {t("pages.mymaor.labels.2")}
        </button>
        <button
          className={classes.popupButton}
          onClick={handleEmailClick}
        >
          {" "}
          <Icon size="xs" name="letter" />
          {t("pages.mymaor.labels.1")}
        </button>
      </div>

      <MailingModal popup={videoNotificationPopup} mailinglistID={mailinglistID} />
      <ParentalGate
        isOpen={gateOpen}
        onSuccess={() => {
          if (gateAction) gateAction();
        }}
        onClose={() => {
          setGateOpen(false);
          setGateAction(null);
        }}
      />
    </>
  );
};

NotificationButtons.propTypes = {
  page: PropTypes.string,
  mailinglistID: PropTypes.number,
};

NotificationButtons.defaultProps = {
  page: "",
};

export default NotificationButtons;
